package com.essntl.features.notification.domain.model

data class NotificationModel(
    val id: String,
    val createdAt: String,
    val title: String,
    val body: String,
    val chatId: String?,
    val timestamp: String?,
    val type: NotificationType?,
) {
    enum class NotificationType {
        Whatsapp, WhatsappCall
    }
}
